import { render } from "./PdrsDataTable.vue?vue&type=template&id=7ef847ae&scoped=true"
import script from "./PdrsDataTable.vue?vue&type=script&lang=js"
export * from "./PdrsDataTable.vue?vue&type=script&lang=js"

import "./PdrsDataTable.vue?vue&type=style&index=0&id=7ef847ae&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef847ae"]])

export default __exports__